import { store } from '@/decorators/store';
import { CrewMember } from '@/entities/CrewMember';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'CrewMemberStore' })
export class CrewMemberStore extends AbstractEntityStore<CrewMember> {
  protected entityIdKey = 'id';
  protected entityLabelKey = 'lastName';
  protected entityValueKey = 'lastName';
}
